import type {RoleLicense} from './RoleLicense';
import type {RoleResourcePermissionSet} from './RoleResourcePermissionSet';

export type FullRole = {
  id: string;
  title: string;
  permissions: Record<string, RoleResourcePermissionSet>;
  system: boolean;
  licenses: Array<RoleLicense>;
};
